<template>
  <a-row :span="24">
    <template v-for="(item,index) in searchOptions">
      <a-col
        :key="item.key"
        :span="item.rowSpan?item.rowSpan:rowSpan"
        v-show="showAll || (!showAll && index<colNum-1)"
      >
        <a-form-item
          :key="item.key"
          :label="item.name"
          :labelCol="item.labelCol?item.labelCol:labelCol"
          :wrapperCol="item.wrapperCol?item.wrapperCol:wrapperCol"
          style="margin-bottom: 8px">
          <a-select
            v-if="item.type==='select'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :options="item.selectOptions"
            :placeholder="item.placeholder?item.placeholder:'请选择'"
          />
          <a-date-picker
            v-else-if="item.type==='date'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :format="item.format?item.format:'YYYY-MM-DD'"
            :valueFormat="item.valueFormat?item.valueFormat:'YYYY-MM-DD'"
            :placeholder="item.placeholder?item.placeholder:'请选择日期'"
          />
          <a-range-picker
            v-else-if="item.type==='rangePicker'"
            :placeholder="['开始时间', '结束时间']"
            :allowClear="true"
            :showTime="item.showTime?item.showTime:false"
            :format="item.format?item.format:'YYYY-MM-DD'"
            :valueFormat="item.valueFormat?item.valueFormat:'YYYY-MM-DD'"
            :mode="['date']"
            @change="(v,arr)=>handleRangePickerChange(v,arr,item)"
          />
          <a-input
            v-else-if="item.type==='textarea'"
            v-model="queryParams[item.key]"
            type="textarea"
            style="width: 100%"
            :allowClear="true"
            :placeholder="item.placeholder"
            :rows="item.rows?item.rows:3"
            :maxlength="item.maxlength"
            :showCount="item.showCount"
          />
          <a-input-number
            v-else-if="item.type==='inputNumber'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :placeholder="item.placeholder?item.placeholder:'请输入'"
            :min="item.min"
            :max="item.max"
            :precision="item.precision"
            :step="item.step"
          />
          <a-radio-group
            v-else-if="item.type==='radio'"
            v-model="queryParams[item.key]"
            :options="item.selectOptions"
            :placeholder="item.placeholder?item.placeholder:'请选择'"
          />
          <a-checkbox-group
            v-else-if="item.type==='checkbox'"
            v-model="queryParams[item.key]"
            :options="item.selectOptions"
            :placeholder="item.placeholder?item.placeholder:'请选择'"
          />
          <a-switch
            v-else-if="item.type==='switch'"
            v-model="queryParams[item.key]"
            :checkedChildren="item.checkedChildren?item.checkedChildren:'是'"
            :unCheckedChildren="item.unCheckedChildren?item.unCheckedChildren:'否'"
          />
          <a-tree-select
            v-else-if="item.type==='treeSelect'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :placeholder="item.placeholder?item.placeholder:'请选择'"
            :treeData="item.treeData"
            :treeCheckable="item.treeCheckable?item.treeCheckable:false"
            :multiple="item.multiple?item.multiple:false"
            :showSearch="item.showSearch?item.showSearch:false"
            :treeNodeFilterProp="item.treeNodeFilterProp?item.treeNodeFilterProp:'title'"
            :replaceFields="item.replaceFields?item.replaceFields:{children:'children', label:'title', key:'key', value:'value'}"
          />
          <a-cascader
            v-else-if="item.type==='cascader'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :placeholder="item.placeholder?item.placeholder:'请选择'"
            :options="item.selectOptions"
            :expandTrigger="item.expandTrigger?item.expandTrigger:'hover'"
            :showSearch="item.showSearch?item.showSearch:false"
            :changeOnSelect="item.changeOnSelect?item.changeOnSelect:false"
          />
          <a-time-picker
            v-else-if="item.type==='timePicker'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :format="item.format?item.format:'HH:mm:ss'"
            :valueFormat="item.valueFormat?item.valueFormat:'HH:mm:ss'"
            :placeholder="item.placeholder?item.placeholder:'请选择时间'"
          />
          <a-month-picker
            v-else-if="item.type==='monthPicker'"
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :format="item.format?item.format:'YYYY-MM'"
            :valueFormat="item.valueFormat?item.valueFormat:'YYYY-MM'"
            :placeholder="item.placeholder?item.placeholder:'请选择月份'"
          />
          <slot
            v-else-if="item.type==='slot'"
            :name="item.key"
            v-bind="item"
          />
          <a-input
            v-else
            v-model="queryParams[item.key]"
            style="width: 100%"
            :allowClear="true"
            :placeholder="item.placeholder"/>
        </a-form-item>
      </a-col>
    </template>
    <a-col v-if="enableSearch" :span="searchSpan?searchSpan:rowSpan" class="btn-ext-box">
      <a-form-item
        label=""
        style="margin-bottom: 8px"
        :colon="false"
        :labelCol="{span:0}">
        <search-combination-button
          :show-advanced="showAdvanced && searchOptions.length>this.colNum-1"
          :unfoldState="showAll"
          :exportMenuList="exportMenuList"
          :exportType="exportType"
          :size="buttonSize"
          @search="searchEvent"
          :showResetButton="showResetButton"
          @reset="resetEvent"
          @export="exportEvent"
          @change="advancedChange"
        >
          <slot v-for="(item,index) in buttonItems" :name="item" :index="index"></slot>
        </search-combination-button>
      </a-form-item>
    </a-col>
  </a-row>
</template>
<script>
import SearchCombinationButton from '../SearchCombinationButton/SearchCombinationButton.vue'

export default {
  name: 'SearchPageHeader',
  components: {
    SearchCombinationButton
  },
  props: {
    /**
     * 搜索配置项
     * {
     *   name:'', //名称
     *   key:'', //搜索字段,当是2个字段时（比如时间范围），则两个字段中间用逗号拼接
     *   type:'', //类型：input/textarea/inputNumber/select/date/rangePicker/timePicker/monthPicker/radio/checkbox/switch/treeSelect/cascader/slot
     *   selectOptions:Array<{label:string,value:string}>, //select/radio/checkbox/cascader使用
     *   format:'', //日期/时间显示格式
     *   valueFormat:'', //日期/时间绑定格式
     *   placeholder:'', //占位提示文字
     *   allowClear:true, //是否显示清除按钮
     *   //inputNumber专属
     *   min:0, max:100, precision:2, step:1,
     *   //textarea专属
     *   rows:3, maxlength:200, showCount:true,
     *   //switch专属
     *   checkedChildren:'是', unCheckedChildren:'否',
     *   //treeSelect专属
     *   treeData:[], treeCheckable:false, multiple:false, showSearch:false, treeNodeFilterProp:'title', replaceFields:{},
     *   //cascader专属
     *   expandTrigger:'hover', changeOnSelect:false,
     * }
     */
    searchOptions: {
      type: Array,
      default: function() {
        return []
      }
    },
    buttonSize: {
      type: String,
      default: 'default'
    },
    /**
     * 是否展示折叠按钮
     */
    showAdvanced: {
      type: Boolean,
      default: true
    },
    showResetButton: {
      type: Boolean,
      default: true
    },
    enableSearch: {
      type: Boolean,
      default: true
    },
    colNum: {
      type: Number,
      default: 3
    },
    labelColSpan: {
      type: Number,
      default: 6
    },
    wrapperColSpan: {
      type: Number,
      default: 18
    },
    // 导出类型  1、是菜单类型  2是按钮类型
    exportType: {
      type: Number,
      default: 0
    },
    /**
     * 搜索参数
     */
    queryParams: {
      type: Object,
      default: function() {
        return {}
      }
    },
    // （导出）菜单列表
    exportMenuList: {
      type: Array,
      default: () => ['CSV', 'Excel']
    },
    buttonItems: {
      type: Array,
      default: function() {
        return []
      }
    },
    /**
     * 搜索模块的占比，总行是 24
     */
    searchSpan: {
      type: Number,
      default: 0
    }
  },
  computed: {
    rowSpan() {
      return this.colNum ? (24 / this.colNum) : 24
    },
    labelCol() {
      return {
        span: this.labelColSpan ? this.labelColSpan : 0
      }
    },
    wrapperCol() {
      return {
        span: this.wrapperColSpan ? this.wrapperColSpan : 0
      }
    }
  },
  data() {
    return {
      showAll: false,
      localParams: {}
    }
  },
  created() {
  },

  mounted() {

  },
  methods: {
    advancedChange(state) {
      this.showAll = state
    },
    handleRangePickerChange(v, arr, item) {
      const splitKeys = item.key.split(',')
      if (splitKeys.length === 2) {
        this.$set(this.queryParams, splitKeys[0], arr[0] ? arr[0] : undefined)
        this.$set(this.queryParams, splitKeys[1], arr[1] ? arr[1] : undefined)
      } else {
        throw new Error(item.name + '的关键字错误，必须是两个字段，使用,来连接')
      }
    },
    resetEvent() {
      if (this.searchOptions.length > 0) {
        this.searchOptions.forEach(item => {
          this.$set(this.queryParams, item.key, undefined)
        })
      }
      this.$emit('reset')
    },
    searchEvent() {
      this.$emit('search')
    },
    exportEvent() {
      this.$emit('export', this.queryParams)
    }
  }
}
</script>

<style scoped lang="less">
.btn-ext-box {
  display: flex;
  align-items: center;
}
</style>
